import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {compose} from 'redux';
import {createStructuredSelector} from 'reselect';
import {BaseComponent} from '../../../components/BaseComponent';
import {Button} from '../../../components/Buttons';
import {Modal, ModalControls} from '../../../components/Modal';
import {selectInvoice} from "../selectors";
import {FormField, FormFields} from "../../../components/FormFields";
import {Input} from "../../../components/Form";
import {VBox} from "../../../components/Box";

const STATE = {
  protectMessage: '',
};

/* eslint-disable react/prefer-stateless-function */
class DeclineInvoiceModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get invoice() {
    return this.props.invoice;
  }

  applySelection() {
    this.props.addInvoiceRelation(this.state.selectedInvoice.id, this.reset.bind(this));
  }

  get modalMsg() {
    return this.props.invoice.exportedAt ?
      (<p>{this.lbl(`invoice.details.declineTip`)}</p>) :
      (<p>{this.lbl(`invoice.details.declineTipNotExported`)}</p>)
  }

  get modalProtectMsg() {
    return (<span><p>{this.lbl('invoice.details.declineProtectMsg')}</p> <p style={{fontWeight: 'bold'}}>{this.correctProtectMessage}</p></span>)
  }

  get correctProtectMessage() {
    return `Decline invoice number ${this.props.invoice.entryNumber}`;
  }

  get disableApplyBtn() {
    return !(this.correctProtectMessage === this.state.protectMessage);
  }

  onConfirm() {
    this.props.onConfirm();
  }

  onCancel() {
    this.props.onCancel();
  }

  render() {
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl(`invoice.details.declineModalTitle`)}>
        {this.modalMsg}
        <FormFields>
          <VBox>
            <p>{this.modalProtectMsg}</p>
            <FormField>
              <Input
                value={this.state.protectMessage}
                name="protectMessage"
                onChange={this.onInputChange.bind(this)}
              />
            </FormField>
          </VBox>
        </FormFields>
        <ModalControls>
          <Button onClick={this.onConfirm.bind(this)} primary disabled={this.disableApplyBtn}>
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.onCancel.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
  );
  }
}

DeclineInvoiceModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const DeclineInvoiceModal = compose(
  withConnect,
  withRouter,
)(DeclineInvoiceModalComp);
